import i18n from '@/i18n';
import { RouteRecordRaw } from 'vue-router';

const communicationRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'communication-overview',
      component: () => import('@/modules/communication/components/overview/Overview.vue'),
      meta: {
         title: `${i18n.global.t('global.communication')} - NxtPlan`,
      },
   },
];
export default communicationRoutes;
